export default "__VITE_ASSET__DF5DGi1F__"